import React, { useEffect } from "react";
import { HP_WEB_SERVICE_PORT } from "../../../utils/constants/others";

const PayLaterRedirection = () => {
  useEffect(() => {
    if (process.env.NODE_ENV === "development") {
      window.location.href = `http://localhost:${HP_WEB_SERVICE_PORT}/z/paylater`;
    } else {
      window.location.href = "/z/paylater";
    }
  }, []);

  return null;
};

export default PayLaterRedirection;
